import type {
	StripeBillingCheckoutPayload as SharedStripeBillingCheckoutPayload,
	StripeBillingCheckoutResponse as SharedStripeBillingCheckoutResponse,
	StripeBillingPortalSessionResponse as SharedStripeBillingPortalSessionResponse,
	StripeBillingSubscriptionSnapshotResponse as SharedStripeBillingSubscriptionSnapshotResponse,
	StripeBillingEventResponse as SharedStripeBillingEventResponse,
} from "le-coffre-resources/dist/Admin/StripeBillingContracts";
import { buildStripeBillingCheckoutPayload as buildSharedStripeBillingCheckoutPayload } from "le-coffre-resources/dist/Admin/StripeBillingContracts";
import { apiV1Paths } from "@Front/Api/helpers/apiClientV1Paths";
export type StripeBillingCheckoutPayload = SharedStripeBillingCheckoutPayload;
export type StripeBillingCheckoutResponse = SharedStripeBillingCheckoutResponse;
export type StripeBillingPortalSessionResponse = SharedStripeBillingPortalSessionResponse;
export type StripeBillingSubscriptionSnapshotResponse = SharedStripeBillingSubscriptionSnapshotResponse;
export type StripeBillingEventResponse = SharedStripeBillingEventResponse;
export type StripeBillingInvoiceResponse = SharedStripeBillingEventResponse;
export type StripeBillingPaymentIntentResponse = SharedStripeBillingEventResponse;

function assertStripeIdentifier(value: string): string {
	const trimmed = value.trim();
	if (trimmed.length === 0) {
		throw new Error("Stripe identifier is required");
	}
	return trimmed;
}

export function buildStripeBillingCheckoutPayload(payload: StripeBillingCheckoutPayload): StripeBillingCheckoutPayload {
	return buildSharedStripeBillingCheckoutPayload(payload);
}

export function buildStripeSubscriptionSnapshotPath(stripeSubscriptionId: string): string {
	return `${apiV1Paths.admin.stripe}/${encodeURIComponent(assertStripeIdentifier(stripeSubscriptionId))}`;
}

export function buildStripePortalSessionPath(stripeSubscriptionId: string): string {
	return `${buildStripeSubscriptionSnapshotPath(stripeSubscriptionId)}/client-portal`;
}

export function buildStripePaymentIntentPath(paymentIntentId: string): string {
	return `${apiV1Paths.admin.stripePaymentIntents}/${encodeURIComponent(assertStripeIdentifier(paymentIntentId))}`;
}

export function buildStripeInvoicePath(invoiceId: string): string {
	return `${apiV1Paths.admin.stripeInvoices}/${encodeURIComponent(assertStripeIdentifier(invoiceId))}`;
}
